import { render, staticRenderFns } from "./items_list.vue?vue&type=template&id=6c3e8b76&scoped=true"
import script from "./items_list.vue?vue&type=script&lang=js"
export * from "./items_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3e8b76",
  null
  
)

export default component.exports